import React, { useEffect, useState } from "react";
import CartItem from "./CartItem";
import { SorszamHelper } from "../../helpers/sorozatszam";

const spentInfo = document.getElementById("spent-info");
const loyaltyLevel = document.getElementById("loyalty-level");
const missingAmount = document.getElementById("missing-amount");
const XYInfo = document.getElementById("XY-info");
const XYamount = document.getElementById("XY-amount");
const XYString = document.getElementById("XY-string");

export default function CartPage(props) {
    let loggedin = props.elem?.dataset?.loggedin.length
        ? props.elem.dataset.loggedin !== "false"
        : props.loggedin;

    let inpayment =
        !(
            typeof props.elem?.dataset?.inpayment == "undefined" ||
            props.elem.dataset.inpayment === "false"
        ) || props.inpayment;

    let [data, setData] = useState({});
    let [loading, setLoading] = useState(true);

    useEffect(() => {
        window.Dibook.cart.fetchCart().then((response) => {
            setData(response);
            setLoading(false);
        });

        let addSubId = window.Dibook.cart.on("itemsAdded", setData);
        let removeSubId = window.Dibook.cart.on("itemsRemoved", setData);

        return () => {
            window.Dibook.cart.off("itemsAdded", addSubId);
            window.Dibook.cart.off("itemsRemoved", removeSubId);
        };
    }, []);

    useEffect(() => {
        if(data?.content && spentInfo && loyaltyLevel && missingAmount) {
            spentInfo.innerHTML = data?.content?.currentQuarterSpending;
            loyaltyLevel.innerHTML = data?.content?.nextQuarterLevel;
            missingAmount.innerHTML = data?.content?.spentNeededForNextLevel;

            spentInfo.parentElement.style.display = "block";
            loyaltyLevel.parentElement.style.display = "block";
            missingAmount.parentElement.style.display = "block";
        }

        const XYDiscounted = data?.content?.data?.cart.filter((item) => item['discount_type'] == 3);
        if(!XYDiscounted || XYDiscounted?.length <= 0) return;
        const postFxSplit = XYDiscounted[0].discount_postfix.split("+");
        const discountInfo = { totalNeeded: parseInt(postFxSplit[0])+parseInt(postFxSplit[1].includes("%") ? 1 : postFxSplit[1]), freeCount: parseInt(postFxSplit[1].includes("%") ? 1 : postFxSplit[1]), type: postFxSplit[1].includes("%") ? 'akciós' : 'ingyenes' };
        const neededForFreeOne = (discountInfo.totalNeeded * Math.floor(XYDiscounted.length / discountInfo.totalNeeded + 1)) - XYDiscounted.length;

        if(neededForFreeOne != 0 && neededForFreeOne != discountInfo.totalNeeded && XYInfo){
            XYInfo.parentElement.style.display = "block";
            XYInfo.innerHTML = neededForFreeOne;
            XYamount.innerHTML = XYDiscounted[0].discount_postfix;
            
            let freeCountString = [];
            for (let i = 0; i < discountInfo.freeCount; i++) {
                const stringValue = SorszamHelper.szamotSzovegesre(discountInfo.totalNeeded - i);
                
                if(i != 0)
                    freeCountString.push("és");
                freeCountString.push(stringValue);
            }
            XYString.innerHTML = freeCountString.reverse().join(" ") + ` legolcsóbb ${discountInfo.type} legyen`;
        } else if(XYInfo != null) {
            XYInfo.parentElement.style.display = "none";   
        }
    }, [data]);

    if (data?.content?.data?.cart?.length > 0) {
        return (
            <section className="order-main justify-content-between p-0 flex-lg-nowrap">
                <div className="cart-list col-lg-8 pl-0 pr-lg-4">
                    {data?.content?.data?.cart.map((item) => (
                        <CartItem key={item.id} item={item} rewardLevel={data.content.rewardLevel} inPayment={inpayment} loyaltyDiscountQuantity={data.content.discountQuantity} />
                    ))}
                </div>
                {!inpayment && (
                    <div className="order-side col-lg-3 pr-0">
                        <div className="new-order-total-container">
                            <div className="new-order-total">
                                <div className="order-total-title">Összesítő</div>
                                <div className="order-total-body">
                                    <div className="order-total-row">
                                        <span className="order-total-item">
                                            Eredeti ár{" "}
                                            {data?.content?.data?.cart?.length > 0 &&
                                                `(${data?.content?.data?.cart?.length} termék)`}
                                        </span>

                                        <span className="order-total-amount">
                                            {window.Dibook.language.formatCurrency(
                                                nullToInt(data?.content?.total) +
                                                    nullToInt(data?.content?.save)
                                            )}
                                        </span>
                                    </div>

                                    {nullToInt(data?.content?.save) > 0 && (
                                        <div className="order-total-row">
                                            <span className="order-total-item">
                                                Akciós kedvezmény
                                            </span>
                                            <span className="order-total-amount">
                                                -{" "}
                                                {window.Dibook.language.formatCurrency(
                                                    nullToInt(data?.content?.save)
                                                )}
                                            </span>
                                        </div>
                                    )}

                                    <div className="order-total-foot">
                                        <div className="order-total-row">
                                            <span className="order-total-item">Fizetendő</span>
                                            <span className="order-total-amount">
                                                {window.Dibook.language.formatCurrency(
                                                    nullToInt(data?.content?.total)
                                                )}
                                            </span>
                                        </div>
                                        
                                        {data?.content?.points > 0 && (
                                            <p className="order-total-points">
                                                <img 
                                                    className="order-total-points-img" 
                                                    src={
                                                        data?.content?.rewardLevel === 1
                                                        ? "/images/icon/customer-discount/bronz-dibook.svg"
                                                        : data?.content?.rewardLevel === 2
                                                        ? "/images/icon/customer-discount/ezust-dibook.svg"
                                                        : data?.content?.rewardLevel === 3
                                                        ? "/images/icon/customer-discount/arany-dibook.svg"
                                                        : data?.content?.rewardLevel === 4
                                                        ? "/images/icon/customer-discount/platina-dibook.svg"
                                                        : "/images/icon/customer-discount/none-dibook.svg"
                                                    } 
                                                    alt="Pont ikon"
                                                />
                                                {data?.content?.points} pont
                                            </p>
                                        )}
                                    </div>

                                    <button
                                        type="submit"
                                        data-toggle={loggedin ? "" : "modal"}
                                        data-target="#loginModal"
                                        className="btn btn-secondary order-action-btn text-uppercase"
                                        onClick={handlePaymentButtonClick}
                                    >
                                        Tovább
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </section>
        );
    } else {
        return (
            <section className="order-main container">
                <div className="w-100 text-center mt-5 mb-5">
                    {loading ? "Egy pillanat..." : "A kosár üres"}
                </div>
            </section>
        );
    }

    function handlePaymentButtonClick(e) {
        e.preventDefault();
        if (loggedin) {
            window.location.href = `${window.location.protocol}//${window.location.host}/fizetes`;
        } else {
            return false;
        }
    }

    function nullToInt(value) {
        return value === null || !value ? 0 : value;
    }
}
